module.exports = new Promise(function (resolve, reject) {
  if (typeof window.RootApps !== 'undefined') return resolve(window.RootApps);
  var base = (window.__SCHEDULER_ENV__ && window.__SCHEDULER_ENV__.REACT_APP_ROOT_APPS_URL) || "";
  var script = document.createElement('script');
  script.src = base + 'js/host-app-entry.js?noCache=' + Date.now();
  script.async = true;
  script.onload = function () { resolve(window.RootApps); };
  script.onerror = function () { reject(new Error('[MF] RootApps could not be loaded: ' + script.src)); };
  document.head.appendChild(script);
});